
import { cropText } from '@packages/toolbox';
import { PropType, defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import { HeaderProfileLink } from 'SharedComponents/header/profile.d';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { DELAY_TOOLTIP } from 'SharedDir/constants/common';

export default defineComponent({
  name: 'HeaderProfile',
  methods: { cropText },
  props: {
    linkList: {
      type: Array as PropType<HeaderProfileLink[]>,
      required: true,
    },
    profileRole: {
      type: String,
      required: false,
      default: '',
    },
    currentProfileType: {
      type: String,
      required: false,
      default: '',
    },
    profileLabel: {
      type: String,
      required: false,
      default: '',
    },
    routeTo: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    return {
      ...useDeviceSize(),
      DELAY_TOOLTIP,
    };
  },
});
